module.exports = __webpack_public_path__ + "img/clinic-terranova.2a90e2c3.jpg";